<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;margin-top:-5px;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <Steps :active="actionList.length" direction="vertical">
                    <Step v-for="(item,index) in actionList" :key="index">
                        <h3>
                            <span :style="'color:'+actionColor(item)">{{item.actionName}}</span>
                            &nbsp;
                            <span>{{item.actionUserRealName}}</span>
                            <div class="flex-center-y" @click="detailShow=true;detail=item;"
                                 style="float:right;margin-top: 11px;margin-right: 5px;color: #1890ff">
                                查看
                                <van-icon name="arrow"/>
                            </div>
                        </h3>
                        <p>{{item.time}}</p>
                    </Step>
                </Steps>
            </List>
        </PullRefresh>
        <Popup v-model="detailShow" position="bottom">
            <div>
                <Cell title="操作名称">
                    <span :style="'color:'+actionColor(detail)">{{detail.actionName}}</span>
                </Cell>
                <Cell title="操作参数" :value="(detail.params||[]).map(item=>(`${item.name}:${item.value}`)).join('，')||'无'"/>
                <Cell title="操作人" :value="detail.actionUserRealName"/>
                <Cell title="操作时间" :value="detail.time"/>
                <Cell title="执行类型">
                    <span :style="'color:'+actionTypeColor(detail)">{{$DICT.getValue('DEVICE_ACTION_EXECUTE_TYPE', detail.executeType)}}</span>
                </Cell>
                <Cell title="执行状态">
                    <span :style="'color:'+actionColor(detail)">{{$DICT.getValue('DEVICE_ACTION_IOTHUB_STATE', detail.iothubState)}}</span>
                </Cell>
            </div>
        </Popup>
    </div>
</template>

<script>
    import {Cell, List, Popup, PullRefresh, Step, Steps, Tag} from "vant";

    export default {
        components: {
            Steps, Step, List, PullRefresh,
            Tag, Popup, Cell
        },
        props: {},
        data() {
            return {
                actionList: [],
                loading: false,
                isReFresh: false,
                finished: false,

                detailShow: false,
                detail: {},
            };
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.action.list({
                    deviceId: this.$route.params.id,
                    size: 20,
                    page: this.actionList.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            res.rows.map(item => item.params = JSON.parse(item.params))
                            this.actionList.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.actionList.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.actionList = [];
                this.onLoad(true);
            },
            actionColor(detail) {
                return {
                    'Success': 'green',
                    'Failed': 'red', 'Discard': 'red',
                    'Pendding': 'green', 'Wait': 'green'
                }[detail.iothubState]
            },
            actionTypeColor(detail) {
                return {
                    Success: 'green',
                    Failed: 'red',
                    Discard: '#FFD200',
                    Pendding: '#FFD200',
                    Wait: '#FFD200',
                }[detail.executeType]
            },
        },
        watch: {}
    };
</script>
